import React, { FC, memo, ReactNode } from 'react';
import ReactPlayer from 'react-player';
// mui components
import { Grid } from '@mui/material';

interface IProps extends React.ComponentProps<typeof ReactPlayer> {}

const DefaultWrapper: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <Grid
      sx={{
        width: '100%',
        height: 'auto',
        '& video': {
          borderRadius: '12px',
        },
      }}
    >
      {children}
    </Grid>
  );
};

const Player: FC<IProps> = ({ wrapper, ...props }) => {
  return <ReactPlayer wrapper={wrapper ?? DefaultWrapper} {...props} />;
};

export default memo(Player);
